import { render, staticRenderFns } from "./portrait_fans.vue?vue&type=template&id=928e3530&scoped=true"
import script from "./portrait_fans.vue?vue&type=script&lang=js"
export * from "./portrait_fans.vue?vue&type=script&lang=js"
import style0 from "./portrait_fans.vue?vue&type=style&index=0&id=928e3530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928e3530",
  null
  
)

export default component.exports